var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Dashboard")]),_vm._v(" "),_c('b-card',{staticClass:"mt-4",attrs:{"title":"Latest Transactions","sub-title":`Showing ${_vm.transactionsLimit} most recent transactions`}},[_c('LatestTransactionTable',{staticClass:"mt-4",attrs:{"limit":_vm.transactionsLimit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }